var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseIcon = function SvgCloseIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.42148 7.00719C8.03096 6.61667 7.39779 6.61667 7.00727 7.00719C6.61675 7.39771 6.61675 8.03088 7.00727 8.4214L10.5859 12L7.00727 15.5786C6.61675 15.9691 6.61675 16.6023 7.00727 16.9928C7.39779 17.3834 8.03096 17.3834 8.42148 16.9928L12.0001 13.4142L15.5787 16.9928C15.9692 17.3834 16.6024 17.3834 16.9929 16.9928C17.3834 16.6023 17.3834 15.9691 16.9929 15.5786L13.4143 12L16.9929 8.4214C17.3834 8.03088 17.3834 7.39771 16.9929 7.00719C16.6024 6.61667 15.9692 6.61667 15.5787 7.00719L12.0001 10.5858L8.42148 7.00719Z",
    fill: "#333333"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon.0be647b1.svg";
export { ForwardRef as ReactComponent };